import { Controller } from "@hotwired/stimulus";

// Open any closed <details> ancestor of a field that fails native constraint
// validation, so the browser's `:invalid` popover isn't hidden behind a
// collapsed accordion. Server-rendered errors are handled separately by
// `Admin::CustomizationsHelper#accordion_open_for?` so this controller
// doesn't need to inspect server-rendered error markup.
export default class extends Controller {
  connect() {
    this.element.addEventListener("invalid", this.reveal, true);
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.reveal, true);
  }

  reveal = (event) => {
    let node = event.target.parentElement;
    while (node && node !== this.element) {
      if (node.tagName === "DETAILS" && !node.open) node.open = true;
      node = node.parentElement;
    }
  };
}
